module.exports = __webpack_public_path__ + "static/wag-tag-cd29b5bb618b098e188eac9fcf076364.svg";